import React from "react";
import styles from "./CategoryRiskLevel.module.css";
import CustomChips from "../chips/custom-chips/CustomChips";

export default function CategoryRiskLevel({ classId, category }) {
	return (
		<CustomChips
			className={`${styles.chip} ${classId || ""}`}
			color="neutral"
			label={category?.categoryName || category?.name}
			size="sm"
		/>
	);
}
